import React from 'react';
import { ReaderPathCheck } from './ReaderPathCheck';
import { Reveal } from './Reveal';
import { PathThread } from './PathThread';
import { HelpCircle } from 'lucide-react';
export function InvisibleReaders() {
  const missingSignals = ['Who read it?', 'What landed?', 'What did they need?', 'What next step fit?'];
  return <section className="py-24 px-6 max-w-4xl mx-auto relative" data-id="element-217">
      <div className="absolute -top-12 left-1/2 -translate-x-1/2" data-id="element-218">
        <PathThread data-id="element-219" />
      </div>

      <div className="text-center mb-20" data-id="element-220">
        <Reveal data-id="element-221">
          <h2 className="text-3xl md:text-5xl font-serif text-navy mb-8 leading-tight" data-id="element-222">
            Most readers never tell you <br data-id="element-223" />
            <span className="italic text-seaglass" data-id="element-224">when the book mattered</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1} data-id="element-225">
          <div className="text-lg text-text-muted leading-relaxed max-w-2xl mx-auto space-y-6" data-id="element-226">
            <p data-id="element-227">
              Someone can buy the book, underline the chapter that sounds
              exactly like their situation, send it to a colleague, bring it
              into a team meeting, and think, "I probably need help with this."
            </p>
            <p data-id="element-228">And still remain invisible to you.</p>
            <p className="font-medium text-navy text-xl" data-id="element-229">
              Not because they did not care. <br className="hidden md:block" data-id="element-230" />
              Because the book never gave them a useful reason to step forward.
            </p>
          </div>
        </Reveal>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-24" data-id="element-231">
        {missingSignals.map((signal, idx) => <Reveal key={idx} delay={0.1 * idx} data-id="element-232">
            <div className="bg-white border border-gray-100 rounded-2xl p-6 text-center shadow-[0_8px_20px_-12px_rgba(26,40,56,0.15)] hover:-translate-y-1 transition-transform duration-300 flex flex-col items-center justify-center min-h-[140px] gap-4 group" data-id="element-233">
              <div className="w-10 h-10 rounded-full bg-paper-dark flex items-center justify-center text-seaglass group-hover:bg-seaglass/10 transition-colors" data-id="element-234">
                <HelpCircle className="w-5 h-5 opacity-50" data-id="element-235" />
              </div>
              <span className="font-serif text-lg text-navy" data-id="element-236">{signal}</span>
            </div>
          </Reveal>)}
      </div>

      <Reveal delay={0.2} data-id="element-237">
        <div id="quick-check-1" className="scroll-mt-32" data-id="element-238">
          <ReaderPathCheck questionId="q2.intent.handRaiserContext" checkLabel="Quick Check · 1 of 8" confirmationText="Saved. This helps check whether serious readers become visible after the book." data-id="element-239" />
        </div>
      </Reveal>
    </section>;
}